var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.5542,
    height: 35,
    rx: 8,
    fill: "#121212",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2952 20.6024C20.7229 20.6024 20.2108 20.8283 19.8193 21.1822L14.4503 18.0572C14.488 17.884 14.5181 17.7108 14.5181 17.5301C14.5181 17.3494 14.488 17.1762 14.4503 17.003L19.759 13.9081C20.1657 14.2846 20.7003 14.5181 21.2952 14.5181C22.5452 14.5181 23.5542 13.509 23.5542 12.259C23.5542 11.009 22.5452 10 21.2952 10C20.0452 10 19.0361 11.009 19.0361 12.259C19.0361 12.4398 19.0663 12.613 19.1039 12.7861L13.7952 15.881C13.3886 15.5045 12.8539 15.2711 12.259 15.2711C11.009 15.2711 10 16.2801 10 17.5301C10 18.7801 11.009 19.7892 12.259 19.7892C12.8539 19.7892 13.3886 19.5557 13.7952 19.1792L19.1566 22.3117C19.119 22.4699 19.0964 22.6355 19.0964 22.8012C19.0964 24.0136 20.0828 25 21.2952 25C22.5075 25 23.494 24.0136 23.494 22.8012C23.494 21.5889 22.5075 20.6024 21.2952 20.6024Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.4669cd1cbb7c48f4e9038de390a227e5.svg";
export { ForwardRef as ReactComponent };